export default {
    // Header Section
    "discover_your": "अपने",
    "nature_report": "चरित्र विश्लेषण",
    "natural_personality_insights": "प्राकृतिक व्यक्तित्व अंतर्दृष्टि",
    "nature_report_description": "व्यापक विश्लेषण के माध्यम से अपने प्रामाणिक व्यक्तित्व और जन्मजात प्रकृति को समझें। अपने जन्म विवरण के आधार पर अपने प्राकृतिक व्यवहार पैटर्न, अंतर्निहित शक्तियों, मूल स्वभाव और प्रामाणिक आत्म-अभिव्यक्ति शैली की खोज करें।",

    // Service Information
    "enter_details_for_nature_analysis": "प्रकृति विश्लेषण के लिए अपना विवरण दर्ज करें",
    "complete_nature_analysis": "संपूर्ण प्रकृति विश्लेषण",
    "service_price": "सेवा मूल्य",
    "comprehensive_nature_analysis_note": "आपके प्राकृतिक व्यक्तित्व और व्यवहारिक पैटर्न का गहरा विश्लेषण",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_natural_vibration": "आपका नाम आपकी प्राकृतिक व्यक्तित्व तरंगों के साथ गूंजता है",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "स्त्री",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_personality_nature": "आपके प्राकृतिक व्यक्तित्व गुणों और तत्वीय प्रकृति निर्धारित करने के लिए आवश्यक",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेजी",
    "hindi": "हिंदी",
    "telugu": "तेलुगू",
    "kannada": "कन्नड़",
    "language_note": "आपका प्रकृति विश्लेषण चुनी गई भाषा में प्रदान किया जाएगा",

    // Core Nature Features
    "personality_traits_analysis": "व्यक्तित्व गुण विश्लेषण",
    "behavioral_patterns_insights": "व्यवहारिक पैटर्न अंतर्दृष्टि",
    "strengths_weaknesses_profile": "शक्तियां और कमजोरियां प्रोफाइल",
    "natural_talents_discovery": "प्राकृतिक प्रतिभाओं की खोज",
    "life_approach_guidance": "जीवन दृष्टिकोण मार्गदर्शन",
    "pdf_download": "व्यापक पीडीएफ रिपोर्ट",

    "what_you_get": "आपके प्रकृति विश्लेषण में क्या शामिल है",
    "comprehensive_personality_profile": "व्यापक व्यक्तित्व प्रोफाइल",
    "natural_behavior_patterns": "प्राकृतिक व्यवहार पैटर्न",
    "innate_talents_abilities": "जन्मजात प्रतिभाएं और क्षमताएं",
    "personal_growth_guidance": "व्यक्तिगत विकास मार्गदर्शन",

    // Actions & Buttons
    "pay_and_generate_analysis": "मेरा प्रकृति विश्लेषण प्राप्त करें",
    "processing_payment": "भुगतान प्रसंस्करण",
    "processing_request": "विश्लेषण तैयार की जा रही है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "nature_analysis_processing": "आपका प्रकृति विश्लेषण हमारे विशेषज्ञ व्यक्तित्व विश्लेषकों द्वारा तैयार किया जा रहा है। आपको अपने प्राकृतिक व्यक्तित्व और व्यवहारिक पैटर्न में विस्तृत अंतर्दृष्टि प्राप्त होगी।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान की गई राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "विश्लेषण डिलीवरी",
    "within_8_hours_delivery_note": "आपकी विस्तृत प्रकृति रिपोर्ट 8 घंटों के भीतर तैयार हो जाएगी",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूरा विश्लेषण इस पर भेजा गया",

    // What You'll Receive
    "what_youll_receive": "आपका प्रकृति विश्लेषण पैकेज",
    "detailed_nature_report": "व्यापक प्रकृति रिपोर्ट (पीडीएफ)",
    "personality_traits_breakdown": "व्यक्तित्व गुण विभाजन",
    "behavioral_insights_guide": "व्यवहारिक अंतर्दृष्टि गाइड",
    "natural_abilities_assessment": "प्राकृतिक क्षमताओं का आकलन",
    "personal_development_roadmap": "व्यक्तिगत विकास रोडमैप",

    // Visual Content
    "sample_nature_analysis": "नमूना प्रकृति विश्लेषण",
    "dominant_nature_type": "प्रभावी प्रकृति प्रकार",
    "sample_nature_reading": "मजबूत नेतृत्व गुणों के साथ संतुलित पृथ्वी-अग्नि प्रकृति",
    "sample_nature_preview": "तत्वीय अंतर्दृष्टि के साथ आपके व्यक्तिगत प्रकृति विश्लेषण का पूर्वावलोकन",
    "nature_elements": "प्रकृति तत्व",

    // Nature Element Types
    "fire": "अग्नि",
    "water": "जल",
    "earth": "पृथ्वी",
    "air": "वायु",
    "ether": "आकाश",
    "nature": "प्रकृति",

    // Status & Processing
    "your_nature_analysis_status": "आपके प्रकृति विश्लेषण की स्थिति",
    "processing_your_analysis": "आपके प्राकृतिक व्यक्तित्व का विश्लेषण",
    "analysis_processing_message": "हमारे व्यक्तित्व विशेषज्ञ आपकी प्रामाणिक प्रकृति और व्यवहारिक प्रवृत्तियों को निर्धारित करने के लिए आपके जन्म पैटर्न का अध्ययन कर रहे हैं।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति में",
    "pending": "कतार में",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्षम",
    "delivery_within_8_hours": "रिपोर्ट 8 घंटों के भीतर तैयार",

    // Support & Contact
    "contact_support": "प्रकृति सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक विवरण पूरा करें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण प्रसंस्करण असफल। हमारी सहायता टीम से संपर्क करें।",

    // Nature-Specific Elements
    "elemental_composition": "तत्वीय संरचना",
    "dominant_element": "प्रभावी तत्व",
    "secondary_elements": "द्वितीयक तत्व",
    "elemental_balance": "तत्वीय संतुलन",
    "natural_constitution": "प्राकृतिक संविधान",
    "temperament_type": "स्वभाव प्रकार",

    // Personality Traits
    "core_personality_traits": "मूल व्यक्तित्व गुण",
    "surface_personality": "सतही व्यक्तित्व",
    "hidden_personality": "छुपा हुआ व्यक्तित्व",
    "authentic_self": "प्रामाणिक स्व",
    "personality_layers": "व्यक्तित्व परतें",
    "character_essence": "चरित्र सार",

    // Behavioral Patterns
    "natural_reactions": "प्राकृतिक प्रतिक्रियाएं",
    "instinctive_responses": "सहज प्रतिक्रियाएं",
    "behavioral_tendencies": "व्यवहारिक प्रवृत्तियां",
    "habitual_patterns": "आदतन पैटर्न",
    "unconscious_behaviors": "अचेतन व्यवहार",
    "automatic_responses": "स्वचालित प्रतिक्रियाएं",

    // Strengths & Abilities
    "natural_strengths": "प्राकृतिक शक्तियां",
    "inherent_abilities": "अंतर्निहित क्षमताएं",
    "inborn_talents": "जन्मजात प्रतिभाएं",
    "natural_gifts": "प्राकृतिक उपहार",
    "core_competencies": "मूल दक्षताएं",
    "instinctive_skills": "सहज कौशल",

    // Weaknesses & Challenges
    "natural_weaknesses": "प्राकृतिक कमजोरियां",
    "blind_spots": "व्यक्तित्व अंधे धब्बे",
    "growth_areas": "विकास के क्षेत्र",
    "challenging_traits": "चुनौतीपूर्ण गुण",
    "limiting_patterns": "सीमित करने वाले पैटर्न",
    "shadow_aspects": "छाया पहलू",

    // Temperament Types
    "sanguine_nature": "रक्त प्रधान प्रकृति",
    "choleric_nature": "पित्त प्रधान प्रकृति",
    "melancholic_nature": "उदासीन प्रकृति",
    "phlegmatic_nature": "कफ प्रधान प्रकृति",
    "mixed_temperament": "मिश्रित स्वभाव",
    "temperament_blend": "स्वभाव मिश्रण",

    // Elemental Natures
    "fire_personality": "अग्नि व्यक्तित्व",
    "water_personality": "जल व्यक्तित्व",
    "earth_personality": "पृथ्वी व्यक्तित्व",
    "air_personality": "वायु व्यक्तित्व",
    "space_personality": "आकाश व्यक्तित्व",
    "elemental_dominance": "तत्वीय प्रभुत्व",

    // Interaction Styles
    "social_nature": "सामाजिक प्रकृति",
    "communication_style": "संचार शैली",
    "interaction_preferences": "बातचीत प्राथमिकताएं",
    "relationship_approach": "रिश्ते का दृष्टिकोण",
    "conflict_style": "संघर्ष समाधान शैली",
    "leadership_nature": "नेतृत्व प्रकृति",

    // Emotional Nature
    "emotional_patterns": "भावनात्मक पैटर्न",
    "feeling_responses": "भावना प्रतिक्रियाएं",
    "emotional_expression": "भावनात्मक अभिव्यक्ति",
    "mood_tendencies": "मूड प्रवृत्तियां",
    "emotional_intelligence": "भावनात्मक बुद्धिमत्ता",
    "sensitivity_levels": "संवेदनशीलता स्तर",

    // Mental Nature
    "thinking_patterns": "सोच पैटर्न",
    "mental_approach": "मानसिक दृष्टिकोण",
    "cognitive_style": "संज्ञानात्मक शैली",
    "learning_style": "सीखने की शैली",
    "decision_making": "निर्णय लेने की शैली",
    "problem_solving": "समस्या समाधान दृष्टिकोण",

    // Physical Nature
    "physical_constitution": "शारीरिक संविधान",
    "energy_patterns": "ऊर्जा पैटर्न",
    "activity_preferences": "गतिविधि प्राथमिकताएं",
    "physical_expressions": "शारीरिक अभिव्यक्तियां",
    "body_language": "प्राकृतिक शारीरिक भाषा",
    "physical_tendencies": "शारीरिक प्रवृत्तियां",

    // Spiritual Nature
    "spiritual_inclinations": "आध्यात्मिक झुकाव",
    "inner_nature": "आंतरिक प्रकृति",
    "soul_expression": "आत्मा अभिव्यक्ति",
    "spiritual_path": "प्राकृतिक आध्यात्मिक पथ",
    "divine_connection": "दिव्य संबंध शैली",
    "transcendental_nature": "पारलौकिक प्रकृति",

    // Life Approach
    "life_philosophy": "प्राकृतिक जीवन दर्शन",
    "approach_to_challenges": "चुनौतियों का दृष्टिकोण",
    "goal_orientation": "लक्ष्य अभिविन्यास",
    "success_definition": "सफलता की परिभाषा",
    "life_priorities": "जीवन प्राथमिकताएं",
    "value_system": "मूल मूल्य प्रणाली",

    // Career Nature
    "work_style": "प्राकृतिक कार्य शैली",
    "career_preferences": "करियर प्राथमिकताएं",
    "professional_nature": "व्यावसायिक प्रकृति",
    "workplace_behavior": "कार्यक्षेत्र व्यवहार",
    "team_dynamics": "टीम डायनामिक्स",
    "professional_growth": "व्यावसायिक विकास पैटर्न",

    // Relationship Nature
    "relationship_style": "रिश्ते की शैली",
    "love_expression": "प्रेम अभिव्यक्ति",
    "friendship_patterns": "मित्रता पैटर्न",
    "family_dynamics": "पारिवारिक गतिशीलता",
    "partnership_nature": "साझेदारी प्रकृति",
    "social_connections": "सामाजिक संबंध",

    // Growth & Development
    "natural_evolution": "प्राकृतिक विकास पथ",
    "growth_potential": "विकास क्षमता",
    "development_areas": "विकास क्षेत्र",
    "transformation_capacity": "परिवर्तन क्षमता",
    "learning_opportunities": "सीखने के अवसर",
    "self_improvement": "आत्म सुधार क्षेत्र",

    // Seasonal Nature
    "seasonal_influences": "मौसमी प्रभाव",
    "cyclical_patterns": "चक्रीय पैटर्न",
    "natural_rhythms": "प्राकृतिक लय",
    "biorhythms": "व्यक्तिगत जैव लय",
    "energy_cycles": "ऊर्जा चक्र",
    "mood_cycles": "मूड चक्र",

    // Environmental Nature
    "environmental_preferences": "पर्यावरणीय प्राथमिकताएं",
    "natural_habitat": "प्राकृतिक आवास",
    "climate_preferences": "जलवायु प्राथमिकताएं",
    "space_requirements": "स्थान आवश्यकताएं",
    "comfort_zones": "आराम क्षेत्र",
    "optimal_environments": "इष्टतम वातावरण",

    // Communication Nature
    "expression_style": "अभिव्यक्ति शैली",
    "listening_style": "सुनने की शैली",
    "verbal_patterns": "मौखिक पैटर्न",
    "non_verbal_communication": "गैर-मौखिक संचार",
    "communication_barriers": "संचार बाधाएं",
    "effective_communication": "प्रभावी संचार सुझाव",

    // Stress & Relaxation
    "stress_patterns": "तनाव पैटर्न",
    "stress_responses": "तनाव प्रतिक्रियाएं",
    "relaxation_needs": "आराम की आवश्यकताएं",
    "recovery_methods": "पुनर्प्राप्ति तरीके",
    "self_care_nature": "स्व-देखभाल प्रकृति",
    "wellness_approaches": "कल्याण दृष्टिकोण",

    // Creative Nature
    "creative_expression": "रचनात्मक अभिव्यक्ति",
    "artistic_inclinations": "कलात्मक झुकाव",
    "innovation_style": "नवाचार शैली",
    "creative_processes": "रचनात्मक प्रक्रियाएं",
    "inspiration_sources": "प्रेरणा स्रोत",
    "creative_blocks": "रचनात्मक बाधाएं और समाधान"
};
